import App from './App.svelte';

function displayBooking(id)
{
	const target = document.getElementById(id);
	const app = new App({target});

	return app;
}

window.displayBooking = displayBooking;


// export default app;